import * as React from "react";
import type { SVGProps } from "react";
const SvgIconCheckbox = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.47 1.07c-.23.03-.37.07-.54.15-.44.22-.75.63-.84 1.1-.04.17-.04 11.19 0 11.35.12.66.67 1.17 1.33 1.26.2.02 10.95.02 11.16 0 .7-.09 1.26-.65 1.35-1.35.02-.2.02-10.95 0-11.16-.08-.65-.55-1.16-1.21-1.33-.1-.02-.5-.03-5.66-.03zm-.03 1.18q-.14.05-.2.2c-.03.07-.03.07-.03 5.55s0 5.48.03 5.55q.06.14.2.2l.08.04h10.96l.08-.04q.14-.05.2-.2c.03-.07.03-.07.03-5.55V2.52l-.04-.08q-.05-.14-.2-.2c-.07-.03-.07-.03-5.55-.03H2.52z"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconCheckbox;
